import { create } from "zustand";
import axios from "../api/axios";
import { useCheckoutStore } from "./checkoutStore";

type AuthState = {
  token: string | null
  user: any
  isAuthLoading: boolean

  setToken: (token: string | null) => void
  setUser: (user: any) => void
  setAuthLoading: (loading: boolean) => void
  switchAccount: (memberId: string) => Promise<void>

  logout: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  token: null,
  user: null,
  isAuthLoading: true,

  setToken: (token) => set({ token }),
  setUser: (user) => set({ user }),
  setAuthLoading: (loading) => set({ isAuthLoading: loading }),

  switchAccount: async (memberId) => {
    const response = await axios.post("/switch-account", {
      member_id: memberId,
    })
    const nextToken = response.data?.token

    if (!nextToken) {
      throw new Error("Token akun tidak ditemukan")
    }

    const me = await axios.get("/me", {
      headers: {
        Authorization: `Bearer ${nextToken}`,
      },
    })

    useCheckoutStore.getState().reset()
    localStorage.removeItem("teleconsult_disclaimer")
    localStorage.setItem("auth_token", nextToken)
    set({ token: nextToken, user: me.data.data })
  },

  logout: () => {
    useCheckoutStore.getState().reset()
    localStorage.removeItem("auth_token")
    set({ token: null, user: null })
  },
}))
